/* eslint-disable @typescript-eslint/unbound-method */
import { inject } from '@angular/core';
import type { NonNullableFormBuilder } from '@angular/forms';
import { FormBuilder, Validators } from '@angular/forms';
import {
    alphaNumericOnly,
    isNotWhitespace,
} from '@app/helpers/validators/custom-validator/custom-validator';

export const configureQRForm = (
    fb: NonNullableFormBuilder = inject(FormBuilder).nonNullable,
) => {
    return fb.group({
        qrName: [
            '',
            [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(256),
                alphaNumericOnly,
                isNotWhitespace,
            ],
        ],
        expiryDate: ['', [Validators.required]],
        description: ['', [Validators.maxLength(1000)]],
        onBoardingOptions: ['', [Validators.required]],
    });
};

export type ConfigureQRForm = ReturnType<typeof configureQRForm>;
